import { useState } from "react";
import * as API from "./api";
import { C } from "./ui/theme";
// Phase 3 (standalone page-file token migration, see linear-brewing-toast.md)
// — wired into Settings (App.js) per user decision on 2026-08-25: kept as a
// generic "Data Provider API Keys" panel even though only `apolloKey` is
// currently read anywhere server-side (server.js's /api/leads/search-apollo
// route) — `hunterKey`/`zoomInfoKey` save to the user's settings record but
// nothing reads them back yet. Restyled onto the shared C tokens (was its
// own tiny local `T` palette).
export default function ApiKeysSettings({ settings, setSettings }) {
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await API.updateUserSettings({ apolloKey: settings.apolloKey||"", hunterKey: settings.hunterKey||"", zoomInfoKey: settings.zoomInfoKey||"" });
      setSaved(true); setTimeout(()=>setSaved(false), 2000);
    } catch(e) { console.error(e); }
    setSaving(false);
  };
  const providers = [
    { label:"Apollo.io API Key", key:"apolloKey", link:"https://developer.apollo.io/keys/", hint:"Paste your Apollo.io API key" },
    { label:"Hunter.io API Key", key:"hunterKey", link:"https://hunter.io/api-keys", hint:"Paste your Hunter.io API key" },
    { label:"ZoomInfo API Key", key:"zoomInfoKey", link:"https://developer.zoominfo.com", hint:"Paste your ZoomInfo API key" },
  ];
  return (
    <div style={{background:C.bgCard,border:"1px solid "+C.border,borderRadius:12,padding:"20px 24px",marginTop:16}}>
      <p style={{fontSize:14,fontWeight:600,color:C.text,marginBottom:4}}>Data Provider API Keys</p>
      <p style={{fontSize:12,color:C.textSub,marginBottom:16}}>Connect your B2B data providers. Keys are saved to your account and persist across sessions.</p>
      <div className="responsive-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
        {providers.map(({label,key,link,hint})=>(
          <div key={key}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
              <label style={{fontSize:11,fontWeight:600,color:C.textSub,textTransform:"uppercase",letterSpacing:".4px"}}>{label}</label>
              <a href={link} target="_blank" rel="noreferrer" style={{fontSize:10,color:C.accent,textDecoration:"none"}}>Get key</a>
            </div>
            <input type="password" value={settings[key]||""} onChange={e=>setSettings(p=>({...p,[key]:e.target.value}))} placeholder={hint} style={{width:"100%",border:"1px solid "+C.border,borderRadius:6,padding:"8px 12px",fontSize:13,outline:"none",boxSizing:"border-box"}}/>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} style={{background:saved?C.green:C.accent,color:"#fff",border:"none",borderRadius:6,padding:"8px 20px",fontSize:13,fontWeight:600,cursor:"pointer",transition:"background .3s"}}>{saving?"Saving...":saved?"Saved!":"Save API Keys"}</button>
    </div>
  );
}